










































































































import Vue from "vue";
import Component from "vue-class-component";

import Card from "@/components/layout/Card.vue";
import Grid from "@/components/layout/Grid.vue";
import Row from "@/components/layout/Row.vue";
import Column from "@/components/layout/Column.vue";
import DeleteDialog from "@/components/basic/DeleteDialog.vue";

import { FormRequestHandler } from "@/forms/FormRequestHandler";
import { LocalStorage } from "../../../storage/LocalStorage";
import SystemKeys from "../../../common/utils/SystemKeys";
import { PlantGraphQLService } from "@/plant/services/PlantGraphQLService";
import { Plant, PlantContactPerson } from "@/plant/services/PlantService";
import { AxiosGraphQLConnection } from "@/gateways/graphql/connections/AxiosGraphQLConnection";
import { AxiosLogger } from "@/logging/AxiosLogger";
import { ConsoleLogger } from "@/logging/ConsoleLogger";
import { Auth } from "../../../common/utils/Auth";
import StorageKeys from "../../../common/utils/StorageKeys";

@Component<PlantContactPersonData>({
  components: {
    Card,
    Grid,
    Row,
    Column,
    DeleteDialog,
    CreateContactPerson: () => import("@/plant/views/CreateContactPerson.vue")
  },
  props: ["plant", "plantRequest", "element"]
})
export default class PlantContactPersonData extends Vue {
  protected components: any[] = [];
  protected storage = new LocalStorage();
  protected editMode = false;
  protected plant!: Plant;
  protected isDeleteDialogShown = false;
  protected toDeleteContactPerson: any = {};

  protected get contactPersons() {
    const defaultContactPersons =
      this.plant?.contactPersons?.filter(p => this.isDefaultContactPerson(p)) ??
      [];
    const otherContactPersons =
      this.plant?.contactPersons?.filter(
        p => !this.isDefaultContactPerson(p)
      ) ?? [];

    return [...defaultContactPersons, ...otherContactPersons];
  }

  protected isDefaultContactPerson(
    contactPerson?: PlantContactPerson
  ): boolean {
    return (
      contactPerson?.phoneNumbers?.some(
        phoneNumber => phoneNumber.isStandard
      ) === true
    );
  }

  protected retry(event: any) {
    this.$emit("retry", event);
    if (this.contactPersons.length === 0) {
      this.editMode = false;
    }
  }

  protected clearComponents() {
    this.components = [];
  }

  protected addContactPersonsButtonClicked() {
    this.components.push({ component: "CreateContactPerson" });
  }

  protected editContactPersonsButtonClicked(contactPerson: PlantContactPerson) {
    this.components.push({ component: "CreateContactPerson", contactPerson });
  }

  protected showDeleteDialog(contactPerson: PlantContactPerson) {
    this.toDeleteContactPerson = contactPerson;
    this.isDeleteDialogShown = true;
  }

  protected deleteContactPersonButtonClicked(
    contactPerson: PlantContactPerson
  ) {
    const connection = new AxiosGraphQLConnection(
      new AxiosLogger(new ConsoleLogger())
    );
    const plantService = new PlantGraphQLService(connection);
    const request = plantService.removePlantContactPerson(
      this.plant,
      contactPerson
    );
    FormRequestHandler.handle(
      request,
      response => {
        if (!response.loading && !response.error) {
          this.isDeleteDialogShown = false;
          this.retry(contactPerson);
        }
      },
      "update-plant-failed"
    );
  }

  protected personAdded(event: any) {
    this.components = [];
    this.retry(event);
  }

  protected findSalutation(id: string) {
    if (!!id) {
      return this.storage.findValue(SystemKeys.salutationsTableKey, id).values[
        SystemKeys.salutationsShortFormKey
      ];
    }
  }

  protected findPhoneAreaCode(id: string) {
    if (!!id) {
      return this.storage.findValue(SystemKeys.countriesTableKey, id).values[
        SystemKeys.countriesAreaCodeKey
      ];
    }
  }

  protected getPhoneTitle(phoneNumberCount: number) {
    let toReturn = "Telefonnummer";
    if (phoneNumberCount > 1) {
      toReturn += "n";
    }
    return toReturn + ":";
  }

  protected canEdit() {
    return Auth.hasPermission(StorageKeys.editPlantAndOperatorPermission);
  }
}
